import { useQuery } from "@tanstack/react-query";
import { fetchDiashow } from "../../../api/fetchDiashow";

export const useDiashowQuery = () =>
  useQuery({
    queryKey: ['diashow'],
    queryFn: () => fetchDiashow()
  })